/**
 * @author yan st
 * @date 2025-10-22 10:51
 * @Description:
 */
/*
*  是否
* */
export const isYes = [
    {value: 1, label: '是'},
    {value: 2, label: '否'}
]

/*
*  合格
* */
export const isOk = [
    {value: 1, label: '合格'},
    {value: 2, label: '不合格'}
]

/*
*机构管理制度情况
* */
export const zhiduOptions = [
    {value: 1, label: '培训教学管理制度'},
    {value: 2, label: '从业人员管理制度'},
    {value: 3, label: '场地和设施管理制度'},
    {value: 4, label: '收费标准及收退费管理制度'},
    {value: 5, label: '收费标准及收退费管理制度'},
    {value: 6, label: '其他制度'},
]

/*
*消防安全情况
* */
export const xiaofangOptions = [
    {value: 1, label: '在住建委进行小微改造工程消防验收备案'},
    {value: 2, label: '有消防安全评估报告'},
    {value: 3, label: '其他消防安全证明材料'},
    {value: 4, label: '无符合安全规定的证明材料'}
]

/*
*机构运营信息 Tab
* */
export const operationOptions = [
    {value: 1, label: '党的建设信息'},
    {value: 2, label: '联系人信息'},
    {value: 3, label: '课程教材信息'},
    {value: 4, label: '教学开展信息'},
    {value: 5, label: '安全管理情况'},
    {value: 6, label: '人员档案信息'},
    {value: 7, label: '行业促进信息'},
]

/*
*培训类型
* */
export const peixunTypeOptions = [
    {value: 1, label: '编程'},
    {value: 2, label: '机器人'},
    {value: 3, label: '科学实验'},
    {value: 4, label: '其他'}
]

/*
* 研学区域
* */
export const yanxuequyuOptions = [
    {value: 1, label: '京内'},
    {value: 2, label: '京外'},
    {value: 3, label: '境外'},
]


/*
*教材来源
* */
export const jiaocaiSource = [
    {value: 1, label: '自编教材'},
    {value: 2, label: '正式出版物'}
]

/*
*参赛名称
* */
export const cansaiOptions = [
    {value: 1, label: '金鹏科技论坛'},
    {value: 2, label: '青少年科技创新大赛'},
    {value: 3, label: '信息学奥赛'},
    {value: 4, label: 'VEX机器人大赛'},
    {value: 5, label: '世界机器人大赛'},
    {value: 6, label: '全国青少年无人机大赛'},
    {value: 7, label: '其他'},
]

/*
*人员类型
* */
export const cpeopleTypeOptions = [
    {value: 1, label: '教师'},
    {value: 2, label: '行政'},
    {value: 3, label: '财务'},
    {value: 4, label: '安保'},
    {value: 5, label: '销售'}
]

/*
*聘用方式
* */
export const pinyongTypeOptions = [
    {value: 1, label: '专职'},
    {value: 2, label: '兼职'},
    {value: 3, label: '其他'}
]

/*
*教师资质
* */
export const jiaoshiZhengOptions = [
    {value: 1, label: '行业认证证书'},
    {value: 2, label: '与培训内容相关领域教师资格证书'},
    {value: 3, label: '与培训内容相关专业本科学历证书'},
    {value: 4, label: '与培训内容相关专业硕士学历证书'},
    {value: 5, label: '与培训内容相关专业博士学历证书'},
    {value: 6, label: '无资质证书'},
]

/*
*政府相关部门荣誉
* */
export const rongyuTypeOptions = [
    {value: 1, label: '国家级荣誉'},
    {value: 2, label: '市级/省部级'},
    {value: 3, label: '区级荣誉'},
    {value: 4, label: '无'}
]

/*
*参与行业互助情况
* */
export const huzhuTypeOptions = [
    {value: 1, label: '整体承接'},
    {value: 2, label: '部分承接'},
    {value: 3, label: '无承接'},
]

/*
*重大事故隐患
* */
export const yinHuanOptions = [
    {value: 1, label: '电气线路私拉乱接、老化破损、超负荷运行，存在短路、过载、接触不良等起火风险'},
    {value: 2, label: '电动自行车或其蓄电池在室内、疏散通道、安全出口处违规停放或充电'},
    {value: 3, label: '违规存放易燃易爆危险品'},
    {value: 4, label: '开展科学实验教学活动，违反安全操作规程，存在火灾、爆炸、中毒、灼伤风险'}
]

/*
* 消防安全风险等级
* */
export const xiaofangLevelOptions = [
    {value: 0, label: '绿'},
    {value: 1, label: '黄'},
    {value: 2, label: '橙'},
    {value: 3, label: '红'},
]

/*
*整改
* */
export const zhengGaiOptions = [
    {value: 1, label: '无需整改'},
    {value: 2, label: '需整改'},
]

/*
*整改
* */
export const GaiWanOptions = [
    {value: 1, label: '未完成整改'},
    {value: 2, label: '完成整改'}
]

/*
*约谈情况
* */
export const yueTanOptions = [
    {value: 1, label: '无需约谈'},
    {value: 2, label: '需约谈'}
]

/*
*投诉渠道
* */
export const tousuTypeOptions = [
    {value: 1, label: '12345市民热线'},
    {value: 2, label: '来电'},
    {value: 3, label: '来访'},
    {value: 4, label: '信访'},
    {value: 5, label: '一体化平台'},
    {value: 6, label: '其他投诉渠道'},
]

/*
* 投诉内容
* */
export const tousuContentOptions = [
    {value: 1, label: '退费'},
    {value: 2, label: '工资纠纷'},
    {value: 3, label: '其他'},
]

/*
*信息变更
* */
export const biangengTypeOptions = [
    {value: 1, label: '人员变动'},
    {value: 2, label: '房屋租赁情况变动'},
    {value: 3, label: '教材变动'},
    {value: 4, label: '消防材料变动'},
    {value: 5, label: '其他需备案的变更事项'}
]

/*
* 未备案原因
* */
export const weibeianTypeOptions = [
    {value: 1, label: '超时备案（超过变更10个工作日）'},
    {value: 2, label: '应备案未备案'}
]

/*
* 重大变更情况
* */
export const bigbiangengOptions = [
    {value: 1, label: '股权变更'},
    {value: 2, label: '注册地址变更'},
    {value: 3, label: '法定代表人变动'},
    {value: 4, label: '实际控制人变动'},
    {value: 5, label: '注册资金变动'},
    {value: 6, label: '机构名称变更'},
]

/*
* 失信情况
* */
export const shixinOptions = [
    {value: 1, label: '被列入严重违法失信名单'},
    {value: 2, label: '法定代表人被列入失信被执行人名单'},
    {value: 3, label: '被列入重大税收违法失信主体名单'},
    {value: 4, label: '被认定为税务非正常户'}
]

/*
* 风险预警级别
* */
export const riskLevelOptions = [
    {value: 0, type: 'gray', label: '信息提示'},
    {value: 1, type: 'yellow', label: '黄色预警'},
    {value: 2, type: 'orange', label: '橙色预警'},
    {value: 3, type: 'red', label: '红色预警'},
]

export const riskLevelAllOptions = [
    {value: '', key: '', label: '全部'},
    ...riskLevelOptions
]

/*
*评定结果
* */
export const evaluateOptions = [
    {value: 1, label: '一星级'},
    {value: 2, label: '二星级'},
    {value: 3, label: '三星级'},
    {value: 4, label: '四星级'},
    {value: 5, label: '五星级'}
]

/*
* 劳动纠纷
* */
export const jiufenOptions = [
    {value: 1, label: '欠薪信息'},
    {value: 2, label: '社保欠缴信息'},
    {value: 3, label: '欠房租'},
]

/*
*违规情况
* */
export const weiguiOptions = [
    {value: 1, label: '未使用规范的培训服务合同'},
    {value: 2, label: '违规设置“大课包”'},
    {value: 3, label: '违规开展学科类培训'},
    {value: 4, label: '其他违规经营情况'}
]

/*
*其他风险信息
* */
export const otherFengxianOptions = [
    {value: 1, label: '机构注册资本非正常原因减资'},
    {value: 2, label: '社保非正常原因减员比例达50%以上“大课包”'}
]


/*
*资金监管风险信息
* */
export const jianguanFengxianOptions = [
    {value: 1, label: '资金存管账户月交易小于3笔或交易金额小于2000元'},
    {value: 2, label: '近一个月在全国平台无实际运营'}
]


/*
*
* */
export const shenTypeOptions = [
    {value: 1, key: '', label: '全部'},
    {value: 2, key: 'num', label: '待审核'}
]


/*
*  有 和 无
* */
export const isHave = [
    {value: 1, label: '有'},
    {value: 2, label: '无'}
]

/*
*  机构状态
* */
export const orgStatusOptions = [
    {value: 1, label: '正常'},
    {value: 2, label: '闭店'}
]

/*
*  闭店原因
* */
export const bidianOptions = [
    {value: 1, label: '正常闭店'},
    {value: 2, label: '非正常闭店'},
    {value: 3, label: '已转型'}
]

/*
*  党组织设置形式
* */
export const dangXingShiOptions = [
    {value: 1, label: '党委'},
    {value: 2, label: '党总支'},
    {value: 3, label: '党支部'},
    {value: 4, label: '联合党支部'}
]

/*
*  隶属关系
* */
export const lisHUgUANxIOptions = [
    {value: 1, label: '地市教育部门/教育工委'},
    {value: 2, label: '地市体育、文旅、科技等部门'},
    {value: 3, label: '区县教育部门/教育工委'},
    {value: 4, label: '区县体育、文旅、科技等部门'},
    {value: 5, label: '区县“两新”组织党工委(非公企业、社会组织)'},
    {value: 6, label: '.科技园区、产业园区等'},
    {value: 7, label: '区县行业协会'},
    {value: 8, label: '街道(乡、镇)'},
    {value: 9, label: '村(社区、居委会)'},
    {value: 10, label: '商圈楼宇'},
    {value: 11, label: '事业单位、公益法人'},
    {value: 12, label: '其他'},
]


/*
*评定结果
* */
export const cardTypeOptions = [
    {value: 0, label: '中国居民身份证'},
    {value: 1, label: '港澳居民来往内地通行证'},
    {value: 2, label: '台湾居民来往大陆通行证'},
    {value: 3, label: '护照'},
    {value: 4, label: '外国人永久居留身份证'},
    {value: 5, label: '港澳台居民居住证'},
    {value: 6, label: '其他证件'},
]


//全部 待督办 预警处理中 待审核 确认预警
export const riskStatusOptions = [
    {value: 0, key: 'all', label: '全部'},
    {value: 1, key: 'duban_1', label: '待督办'},
    {value: 2, key: 'duban_2', label: '预警处理中'},
    {value: 3, key: 'shenhe', label: '待审核'},
    {value: 4, key: 'queren', label: '确认预警'}
]

//处理状态 0待督办1已督办2待审核3已拒绝4已解除
export const riskStatusOptions2 = [
    {value: 0, type: 'orange', label: '待督办'},
    {value: 1, type: 'green', label: '已督办'},
    {value: 2, type: 'red', label: '待审核'},
    {value: 3, type: 'red', label: '已拒绝'},
    {value: 4, type: 'gary', label: '已解除'}
]


//评定状态 0全部1未开始2进行中3已结束
export const evaluateStatusOptions = [
    {value: 0, key: 'all', label: '全部'},
    {value: 1, key: 'wait', label: '未开始'},
    {value: 2, key: 'doing', label: '进行中'},
    {value: 3, key: 'end', label: '已结束'}
]
//星评结果
export const evaluateResultOptions = [
    {value: 5, key: 'five', label: '五星'},
    {value: 4, key: 'four', label: '四星'},
    {value: 3, key: 'three', label: '三星'},
    {value: 2, key: 'two', label: '二星'},
    {value: 1, key: 'one', label: '一星'},
]

//异议申诉 状态 待审核 受理中 已拒绝 已完成
export const objectionAppealStatusOptions = [
    {value: -1, key: 'wait', label: '已撤销'},
    {value: 0, key: 'wait', label: '待审核'},
    {value: 1, key: 'doing', label: '受理中'},
    {value: 2, key: 'refuse', label: '已拒绝'},
    {value: 3, key: 'end', label: '已完成'}
]

//操作日志 1机构管理2星级评定3预警管理4信息公示管理5权限管理
export const operateLogTypeOptions = [
    {value: 1, key: 'org', label: '机构管理'},
    {value: 2, key: 'evaluate', label: '星级评定'},
    {value: 3, key: 'risk', label: '预警管理'},
    {value: 4, key: 'info', label: '信息公示管理'},
    {value: 5, key: 'power', label: '权限管理'},
]













